
<template>
	<div>
		<div class="row">
			<div class="col-md-12">
				<div class="card">
					<div class="card-header">Добавление нового сотрудника</div>
					<div class="card-body">
						<b-alert :show="showAlertError" variant="danger">
							<ul>
								<li v-for="(error, key) in errors" :key="key">{{ error[key] }}</li>
							</ul>
						</b-alert>

						<b-alert variant="success"
							dismissible
							:show="showAlertSucces"
							@dismissed="showAlertSucces=false">
							<strong>Новый сотрудник успешно добавлен!</strong>
						</b-alert>

						<div class="row">
							<div class="col-md-6">
								<b-form @submit="submitFormHandler" ref="form">
									<b-form-group label="Имя" :class="{ 'has-error': typeof this.errors['first_name'] !== 'undefined' }">
										<b-form-input
											v-model="form.firstName"
											autocomplete="off"
											required>
										</b-form-input>
										<div class="invalid-feedback">{{ getError('first_name') }}</div>
									</b-form-group>
									<b-form-group label="Фамилия" :class="{ 'has-error': typeof this.errors['last_name'] !== 'undefined' }">
										<b-form-input
											v-model="form.lastName"
											autocomplete="off"
											required>
										</b-form-input>
										<div class="invalid-feedback">{{ getError('last_name') }}</div>
									</b-form-group>
									<!-- email -->
									<b-form-group label="Адрес электроной почты" :class="{ 'has-error': typeof this.errors['email'] !== 'undefined' }">
										<b-form-input
											v-model="form.email"
                      autocomplete="off"
											required>
										</b-form-input>
										<div class="invalid-feedback">{{ getError('email') }}</div>
									</b-form-group>
									<!-- password -->
									<fieldset class="b-form-group form-group horizontal" :class="{ 'has-error': typeof this.errors['password'] !== 'undefined' }">
										<vue-password-strength
											value="form.password"
											labelText="Пароль"
											placeholder=""
											inputGroupClass=""
											labelClass="col-form-label"
											inputClass="form-control"
											@inputChange="passwordChangeHandler"
										/>
										<div class="invalid-feedback">{{ getError('password') }}</div>
									</fieldset>
									<b-form-group id="role" label="Роль" label-for="role" class="is-required">
										<select class="form-control" v-model="form.role">
											<option v-for="(role, key) in roles" :key="key" :label="role.name" :value="role.system_name"></option>
										</select>
									</b-form-group>
								</b-form>
							</div>
						</div>
					</div>
					<div class="card-footer">
						<b-button variant="primary" @click="submitFormHandler('form')">Сохранить нового сотрудника</b-button>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
import VuePasswordStrength from 'vue-password-strength'
import userHTTP from '@/api/modules/user/user'
import ProductSelect from '@/components/product/ProductSelect'
import Vue from 'vue'
import store from '@/store'
export default {
	components: {
		VuePasswordStrength,
		'product-select': ProductSelect
	},
	data () {
		return {
			loaded: true,
			showAlertError: false,
			showAlertSucces: false,
			userId: '',
			type: null,
			role: '',
			roles: [],
			status: '',
			form: {},
			errors: {}
		}
	},
	created () {
		this.userId = this.$route.params.id
		this.roleAll()
	},
	mounted () {},
	methods: {
		getError (key) {
			if (typeof this.errors[key] !== 'undefined') {
				return this.errors[key][0]
			}
		},
		submitFormHandler (formName) {
			this.showAlertSucces = false
			let data = {
				first_name: this.form.firstName,
				last_name: this.form.lastName,
				email: this.form.email,
				password: this.form.password,
				role: this.form.role
			}

			userHTTP.create(data).then((result) => {
				this.clearErrors()
				this.showAlertSucces = true
				this.clearForm()
			}, (response) => {
				if (response.hasOwnProperty('errors')) {
					this.clearErrors()
					const errors = response.errors
					for (let key in errors) {
						this.errors[key] = errors[key]
					}
				}
			})
		},
		clearForm () {
			let inputs = this.$refs.form.querySelectorAll('input')
			Object.keys(this.form).forEach((key, index) => {
				this.form[key] = ''
			})
			inputs.forEach((input) => {
				input.value = ''
			})
		},
		clearErrors () {
			this.errors = []
		},
		passwordChangeHandler (value) {
			this.form.password = value
		},
		roleAll () {
			Vue.http.get(store.state.apiURL + '/v1/user/roles').then((response) => {
				this.roles = response.body
			})
		}
	}
}
</script>
<style>
	.el-alert {
		margin-bottom: 15px;
	}
</style>



// WEBPACK FOOTER //
// src/pages/user/create.vue